import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group d-flex" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_file_input = _resolveComponent("file-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: _ctx.label,
          text: _ctx.label
        }, null, 8, ["localizedKey", "text"])
      ]),
      _createElementVNode("div", null, [
        (_ctx.canUpload)
          ? (_openBlock(), _createBlock(_component_file_input, {
              key: 0,
              modelValue: _ctx.fileToUpload,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileToUpload) = $event))
            }, null, 8, ["modelValue"]))
          : (_openBlock(), _createBlock(_component_localized_text, {
              key: 1,
              localizedKey: "Salva prima di caricare allegati",
              text: "Salva prima di caricare allegati"
            }))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
          disabled: !_ctx.fileToUpload
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Carica",
            text: "Carica"
          })
        ], 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "preview", {}, () => [
        (_ctx.localValue && _ctx.localValue.publicUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              style: {"max-height":"120px"},
              src: _ctx.localValue.publicUrl
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}